/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import { SupportingDocumentsProps } from "../models";
import { EmployeeRecord, LinkObject } from "../../model";

import { questions } from "../questions";

import { makeSubmittableHealthSurveillanceQuestionnaire } from "./makeSubmittableHealthSurveillanceQuestionnaire";
import { OldHealthSurveillanceQuestionnaire, HealthSurveillanceQuestionnaireKey } from "./OldHealthSurveillanceQuestionnaire";

interface Props {
    getOrgLevels?: () => Promise<LinkObject[]>;
    recordMedicalsSeparately?: boolean;
    removeMedicalSections?: boolean;
    autoFill?: boolean;
    employeeRecord?: EmployeeRecord;
}

type AllProps = Props & SupportingDocumentsProps;

/**
 * @deprecated Replaced with HealthSurveillanceQuestionnaire with the readonly prop set to false
 */
export const SubmittableHealthSurveillanceEmployeeQuestionnaire =
    makeSubmittableHealthSurveillanceQuestionnaire<AllProps>(
        OldHealthSurveillanceQuestionnaire,
        HealthSurveillanceQuestionnaireKey,
        questions
    );
